import { Control } from './class/control.class';
import { DynamicFlatNode } from './DynamicFlatNode.class';
import { TreeLevel } from './enum';
import { TreeEntityType } from './enum/TreeEntityType';
import type { IChannel } from './interfaces/channel.interface';
import type { SharedDTO } from './interfaces/shared-dto.interface';

export class Channel implements IChannel {
  /**
   *
   * @param args
   */
  constructor(args: Partial<Channel>) {
    if (args) {
      Object.assign(this, args);
    }
    if (this.unit) {
      this.unit = this.unit.replace('om:', '').replace(/^\w/, (c) => c.toUpperCase());
    }
  }
  /**
   *
   */
  unit!: string;
  /**
   *
   */
  firstTimestamp!: string;
  /**
   *
   */
  latestTimestamp!: string;
  /**
   *
   */
  identifier!: string;
  /**
   *
   */
  parentIdentifier!: string;
  /**
   *
   */
  name!: string;
  /**
   *
   */
  description!: string;
  /**
   *
   */
  get entity(): IChannel {
    return {
      unit: this.unit,
      firstTimestamp: this.firstTimestamp,
      latestTimestamp: this.latestTimestamp,
      identifier: this.identifier,
      parentIdentifier: this.parentIdentifier,
      name: this.name,
      description: this.description,
    };
  }
  /**
   *
   * @param c
   * @returns
   */
  public toControl(c: SharedDTO) {
    return new Control({
      id: this.identifier,
      label: this.name,
      description: this.description,
      unit: this.unit,
      formControl: `${this.name}_${c.identifier}`,
      raw_label: this.name,
      datasource: c.identifier,
    });
  }
  /**
   *
   * @returns
   */
  public toDynamicFlatNode() {
    return new DynamicFlatNode({
      label: this.name,
      id: this.identifier,
      level: TreeLevel.Channel,
      expandable: false,
      isLoading: false,
      type: TreeEntityType.CHANNEL,
      entity: this.entity,
    });
  }
}
